import React from 'react';
import './OnboardingTooltip.css';

const OnboardingTooltip = ({ id, seenHints, onDismiss, text, position = 'top', children }) => {
  const isSeen = seenHints?.includes(id);

  if (isSeen) return children;

  const handleDismiss = () => {
    if (typeof onDismiss === 'function') {
      onDismiss(id);
    } else {
      console.warn(`OnboardingTooltip: onDismiss is not a function for hint ${id}`);
    }
  };

  return (
    <div className="onboarding-tooltip-wrapper">
      {children}
      <div className={`onboarding-tooltip-bubble bubble-${position}`}>
        <div className="tooltip-content">
          <span className="material-symbols-outlined tooltip-icon">lightbulb</span>
          <p>{text}</p>
        </div>
        <button className="tooltip-dismiss-btn" onClick={handleDismiss}>Got it</button>
        <div className="tooltip-arrow"></div>
      </div>
    </div>
  );
};

export default OnboardingTooltip;